import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';

@Component({
  selector: 'app-carousel-with-slidebar',
  templateUrl: './carousel-with-slidebar.component.html',
  styleUrls: ['./carousel-with-slidebar.component.scss']
})

export class carouselWithSlidebarComponent {
  carouselTypesList: string[] = ['with-swiper','swiper-without-slidebar', 'without-swiper'];
  carouselTypes = 'with-swiper' as string;
  showPagination = true as boolean;
  showNavigation =true as boolean;
  activeStep = 0 as number;
    steps = Array.from({ length: 6 }, (_, i) => ({
    id: i + 1,
    unitTitle: `Unit Name ${i + 1}`,
    title: `Lesson ${i + 1}`,
    description: `This is content for lesson ${i + 1}. It contains details and example text for the user.`,
  }));
  isDesktopView= true as boolean;

   @ViewChild('sidebar') sidebar!: ElementRef;
   @ViewChild('swiperEl') swiperEl!: ElementRef;

  @HostListener('window:resize', ['$event'])
  onResize() {
    if (window.innerWidth < 1024) {
      this.isDesktopView = false;
    } else {
      this.isDesktopView = true;
    }
  }

  constructor(readonly _cd: ChangeDetectorRef){}

  ngOnInit(): void {
    this.onResize();
  }

  activeTabEvent(index: number) {
    this.activeStep = index;
    this._cd.detectChanges();
  }

  selectStep(index: number) {
    this.activeStep = index;
    this._cd.detectChanges();
    const slidebar:any = document.getElementsByTagName('nav')
      if (slidebar && slidebar.length) {
      const buttons = slidebar[0]?.querySelectorAll('button');
      const activeButton = buttons[this.activeStep];
      activeButton.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    document.getElementsByTagName('swiper-container')[0]?.swiper?.slideTo(index);
  }
}